import Icon from "../Icon";

const close = `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />`;

export default Icon(close);
